@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.RunSelectedStepTagBadge {

  @extend %font-family-primary;

  background: $theme-test-case-tag-color;
  font-size: $font-size-small;
  font-weight: $font-weight-semibold;
  background: $theme-badge-tag-background-color;
  color: $theme-test-case-badge-text;
  padding: 4px 3px;
  border-radius: 4px;
  align-items: center;
  line-height: 16px;
  display: inline-block;

  // trancate text
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 4px;

  &.inline-block {
    display: inline-block;
  }

  &.block {
    display: block;
  }

  &.flex {
    display: flex;
  }
}
